import { CommonModule, NgFor } from '@angular/common';
import { Component, computed, effect, inject, OnInit, signal } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ActivatedRoute, RouterModule, Router } from '@angular/router';
import { EmbeddedPaymentService } from '../../../services/epf/embedded-payment.service';
import { ApiService } from '../../../services/api.service';

@Component({
  selector: 'app-payment-successful',
  imports: [CommonModule, ButtonModule, DialogModule, RouterModule, NgFor],
  templateUrl: './payment-successful.component.html',
  styleUrl: './payment-successful.component.scss'
})
export class PaymentSuccessfulComponent implements OnInit {

  visible: boolean = false;
  transactionType: string = '';
  auctionId: number = 0;
  total: number = 0;
  fee: number = 0;
  totalAmount: number | null = null;
  visibl: number | null = null;

  responseToken: string = '';


  epfService = inject(EmbeddedPaymentService);
  apiService = inject(ApiService);
  router = inject(Router);

  thankYouPageDataSignal = this.epfService.thankYouPageDataSignal;

  protected currency = computed(() => this.apiService.auctionConfigSignal()?.currency ?? '')


  isDonation: boolean = false;
  isPurchaseItem: boolean = false
  isFromBidderCommunity = signal(false);

  transactionLabel = computed(() => {
    const data = this.thankYouPageDataSignal();
    if (!data) return false;

    switch (data.transactionType) {
      case 'BUY_NOW':
        this.isPurchaseItem = true;
        return data.lines[0]?.name ?? 'Item';
      case 'CASH_DONATION':
        this.isPurchaseItem = true;
        return 'Donation';
      case 'TICKET_ORDER':
        this.isPurchaseItem = true;
        return data.lines[0]?.name ?? 'Item';

      default:
        return 'Transaction';
    }

  })

  totalWithFee = computed(() => {
    const data = this.thankYouPageDataSignal();

    if (!data) return 0;
    this.apiService.getAuctionConfig(data.auctionId).subscribe();

    const linesTotal = data.lines.reduce((sum, item) => sum + item.value * (item.quantity ?? 1), 0);
    return (linesTotal + data.fee).toFixed(2);

  })

  constructor(private route: ActivatedRoute) {

    effect(() => {
      const data = this.epfService.thankYouPageDataSignal();
      if (data) {
        // console.log(data)
        this.visible = true;
        this.isFromBidderCommunity.set(data.isFromBidderCommunity);
      }
    });
  }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      this.responseToken = params['sessionToken'];

      // console.log('response token in thank you page: ', this.responseToken)

      if (this.responseToken) {
        this.getPaymentDetails(this.responseToken);
      }
    });
  }


  getPaymentDetails(token: string) {
    if (typeof window !== 'undefined') {
      // console.log('ThkPageData executed')
      this.epfService.getThankYouPageData(token).subscribe();
    }
  }

  getTotal(): number {

    return 0;
  }

  goAfterThankYou(): void {
    if (this.isFromBidderCommunity()) {
      this.router.navigate(['/']);
    } else {
      this.router.navigate(['/auction', this.thankYouPageDataSignal()?.auctionId]);
    }
  }


}


